export default function ($http) {
    return function (postCode) {
        return $http
            .get(`api/postcode/${ postCode }`)
            .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/services/lookUpPostCode.js